import React from 'react';
import { connect } from 'react-redux';

import * as selectors from './selectors';
import Plans from './Plans';

const PlansConnected = (props) => <Plans {...props} />;

const mapStateToProps = (state, props) => ({
  priceAdvanced: selectors.selectPriceAdvanced(state, props),
  planAdvanced: selectors.selectPlanAdvanced(state, props),
  priceProfessional: selectors.selectPriceProfessional(state, props),
  planProfessional: selectors.selectPlanProfessional(state, props),
});

export default connect(mapStateToProps)(PlansConnected);
